import type {
  ApiResponse,
  PiAccessConfigType,
  PiAccessSchemaType,
  PiAccessStatusResponseType,
} from '@asetquhub/validation';
import { api } from '../lib/axios';

export type PiAccessConfig = PiAccessConfigType;
export type PiAccess = PiAccessSchemaType;
export type PiAccessStatus = PiAccessStatusResponseType;

/** Harga PiAccess dari pi_access_config — IDR-based per tier. */
export interface PiAccessPricingConfig {
  priceIdr: string;
  priceIdrAsetraclub: string;
  updatedBy?: string;
  updatedAt: number;
}

class PiAccessService {
  async getStatus(): Promise<PiAccessStatus> {
    const response = await api.get<ApiResponse<PiAccessStatus>>('/api/piaccess/status');
    return response.data.data!;
  }

  async getPricingConfig(): Promise<PiAccessPricingConfig> {
    const response = await api.get<ApiResponse<PiAccessPricingConfig>>('/api/piaccess/config');
    return response.data.data!;
  }
}

export const piAccessService = new PiAccessService();
